export const DOCUMENTOS_NUMERO_STRING = {
  CEDULA_CIUDADANIA: '1',
}

export const LONGITUD_CARACTERES = {
  LONGITUD_OCHO_CARACTERES: 8,
}
